import {
  ElementType,
  isValidElement,
  PropsWithChildren,
  ReactElement,
  useMemo,
  Children
} from "react";
import { findComponentChild } from "../../../tools/components";
import { classNames } from "@ct-react/core";

import "./twoCol.scss";
import Skeleton from "react-loading-skeleton";

type ValidChildren = ReactElement<any, typeof Text> | ReactElement<any, typeof Image>;

type Props = {
  as?: ElementType;
  className?: string;
  children: ValidChildren[];
  title?: string
}

export const Text = ({ children }: PropsWithChildren) => children;
export const Image = ({ children }: PropsWithChildren) => children;


const TwoCol = ({ as: Tag = "div", className, title, children: propsChildren }: Props) => {

  const wrapperClasses = classNames("wrap", "touch-scroll", className);

  const children = useMemo(() => Children.toArray(propsChildren).filter(isValidElement), [ propsChildren ]);
  const text = useMemo(() => findComponentChild(children, Text), [ children ]);
  const image = useMemo(() => findComponentChild(children, Image), [ children ]);


  return (
    <Tag className={wrapperClasses}>
      <div className="twoCol">
        {!!title && <h2>{title}</h2>}
        <div className="text">
          {text}
        </div>

        <div className="image">
          {image}
        </div>
      </div>
    </Tag>);

}

export default TwoCol;
